export const state = {
  book: {},
  sectionIds: [],
  sections: {},
  sheets: {}
};
